module.exports = __webpack_public_path__ + "img/southsudan.2c10a316.svg";